// @flow

import React from 'react';
import moment from 'moment';
import {
  getRetailTableCellObject,
  trackCN,
  getFormattedDateAndTime,
  removeUnderScore
} from '../../../../services/helpers';

export const headers = [
  { label: 'CN Number', key: 'cnote' },
  { label: 'Pickup Date', key: 'pickupDate' },
  { label: 'Client / Client Code', key: 'clientName' },
  { label: 'Current OU', key: 'currentLocation' },
  { label: 'From Location', key: 'fromHub' },
  { label: 'Next OU', key: 'nextLocation' },
  { label: 'To Location', key: 'toHub' },
  { label: 'CPD', key: 'promisedDeliveryDateTime' },
  { label: 'EDD / ADD (Hrs)', key: 'estimatedDeliveryDateTime' },
  { label: 'Weight (Kgs)', key: 'weight' },
  { label: 'Status', key: 'status' }
];

const referenceTypeMapping = {
  CNOTE: 'CN',
  INVOICE: 'Invoice',
  EWB: 'EWB',
  CLIENT_INTEGRATION_IDENTIFIER: 'Integration Booking Id',
  AMAZON_PO: 'AMAZON_PO',
  CLIENT_SHIPMENT_CODE: 'Client id',
  BOX_REF_NUMBER: 'Ref No.'
};

export function showEddAdd(estimatedDeliveryDateTime, status) {
  if (status === 'DELIVERED') {
    return moment(estimatedDeliveryDateTime)
      .utcOffset('+05:30')
      .format('ddd DD-MMM-YYYY, hh:mm A');
  }
  estimatedDeliveryDateTime = Math.round(
    (estimatedDeliveryDateTime - moment()) / 3600000
  );
  return estimatedDeliveryDateTime;
}

export const internalTrackingDashboardConfig = {
  // config for internal users
  columns: [
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[0].label,
      sortable: false,
      key: headers[0].key,
      Cell: (row: Object) => (
        <div className="l-row a-center">
          {getRetailTableCellObject(
            row.original && row.original.cnote,
            '',
            row.original,
            trackCN,
            'cn-highlight'
          )}
        </div>
      )
    },
    {
      Header: headers[1].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[1].key,
      formatter: (row: Object) =>
        row.pickupDate && new Date(row.pickupDate).toDateString(),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.pickupDate &&
            new Date(row.original.pickupDate).toDateString(),
          '',
          row.original
        )
    },
    {
      Header: headers[2].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[2].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.clientName,
          row.original && row.original.clientCode,
          row.original
        )
    },
    {
      Header: headers[3].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[3].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.currentLocation && row.original.currentLocation,
          '',
          row.original
        )
    },
    {
      Header: headers[4].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[4].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.fromHub,
          '',
          row.original
        )
    },
    {
      Header: headers[5].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[5].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.nextLocation && row.original.nextLocation,
          '',
          row.original
        )
    },
    {
      Header: headers[6].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[6].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.toHub,
          '',
          row.original
        )
    },
    {
      Header: headers[7].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[7].key,
      formatter: (row: Object) =>
        row && new Date(row.promisedDeliveryDateTime).toDateString(),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.promisedDeliveryDateTime &&
            new Date(row.original.promisedDeliveryDateTime).toDateString(),
          '',
          row.original
        )
    },
    {
      Header: headers[8].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[8].key,
      formatter: (row: Object) =>
        showEddAdd(row.estimatedDeliveryDateTime, row.status),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.status &&
            showEddAdd(
              row.original.estimatedDeliveryDateTime,
              row.original.status
            ),
          '',
          row.original
        )
    },
    {
      Header: headers[9].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[9].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.weight,
          '',
          row.original
        )
    },
    {
      Header: headers[10].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[10].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.status,
          '',
          row.original
        )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: "No CN's to Track",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const externalTrackingDashboardConfig = {
  // config for external and client users
  columns: [
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[0].label,
      sortable: false,
      key: headers[0].key,
      Cell: (row: Object) => (
        <div className="l-row a-center">
          {getRetailTableCellObject(
            row.original && row.original.cnote,
            '',
            row.original,
            trackCN,
            'cn-highlight'
          )}
        </div>
      )
    },
    {
      Header: headers[1].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[1].key,
      formatter: (row: Object) =>
        row.pickupDate && new Date(row.pickupDate).toDateString(),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.pickupDate &&
            new Date(row.original.pickupDate).toDateString(),
          '',
          row.original
        )
    },
    {
      Header: headers[2].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[2].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.clientName,
          row.original && row.original.clientCode,
          row.original
        )
    },
    {
      Header: headers[3].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[3].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.currentLocation && row.original.currentLocation,
          '',
          row.original
        )
    },
    {
      Header: headers[4].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[4].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.fromHub,
          '',
          row.original
        )
    },
    {
      Header: headers[5].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[5].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.nextLocation && row.original.nextLocation,
          '',
          row.original
        )
    },
    {
      Header: headers[6].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[6].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.toHub,
          '',
          row.original
        )
    },
    {
      Header: headers[7].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[7].key,
      formatter: (row: Object) =>
        row && new Date(row.promisedDeliveryDateTime).toDateString(),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.promisedDeliveryDateTime &&
            new Date(row.original.promisedDeliveryDateTime).toDateString(),
          '',
          row.original
        )
    },
    {
      Header: headers[8].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[8].key,
      formatter: (row: Object) =>
        showEddAdd(row.estimatedDeliveryDateTime, row.status),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.status &&
            showEddAdd(
              row.original.estimatedDeliveryDateTime,
              row.original.status
            ),
          '',
          row.original
        )
    },
    {
      Header: headers[9].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[9].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.weight,
          '',
          row.original
        )
    },
    {
      Header: headers[10].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[10].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.status,
          '',
          row.original
        )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: "No CN's to Track",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

function returnTrackingColumns(inputConfig: Object) {
  const toReturn = Object.assign({}, inputConfig);
  toReturn.columns[0] = {
    headerClassName: 'flex-11 zt-custom-th',
    className: 'zt-custom-td flex-11 overflow--visible',
    Header: headers[0].label,
    sortable: false,
    key: headers[0].key,
    Cell: (row: Object) => {
      let referenceString = '';
      let referenceCompleteString = '';

      (row.original.searchReferenceResponseDtoList || []).forEach(
        (item, index) => {
          referenceString += `${referenceTypeMapping[item.referenceType]} ${
            item.referenceNumber && item.referenceNumber.length > 12
              ? `${item.referenceNumber.substring(0, 12)}...`
              : item.referenceNumber
          }`;
          referenceCompleteString += `${item.referenceType} ${item.referenceNumber}`;
          if (
            index !==
            row.original.searchReferenceResponseDtoList.length - 1
          ) {
            referenceString += ', ';
            referenceCompleteString += ', ';
          }
        }
      );
      return (
        <div className="l-row a-center">
          {getRetailTableCellObject(
            row.original && row.original.cnote,
            '',
            row.original,
            trackCN,
            'cn-highlight red'
          )}
          {referenceString && (
            <div className="ribbon" title={referenceCompleteString}>
              <div className="ribbon-text">{referenceString}</div>
            </div>
          )}
        </div>
      );
    }
  };

  // the following change is done to show AD details in case the backend sends it
  toReturn.columns[toReturn.columns.length - 1] = {
    Header: headers[toReturn.columns.length - 1].label,
    headerClassName: 'flex-11 zt-custom-th',
    className: 'zt-custom-td flex-11 overflow--visible',
    sortable: false,
    key: headers[toReturn.columns.length - 1].key,
    Cell: (row: Object) => {
      if (
        row.original.appointmentDeliveryDateTime &&
        row.original.appointmentDeliveryStatus
      ) {
        const appointmentDetailsString = `Appointment Slot and Status - ${getFormattedDateAndTime(
          row.original.appointmentDeliveryDateTime
        )},  ${removeUnderScore(row.original.appointmentDeliveryStatus)}`;
        return (
          <div className="l-row a-center">
            {getRetailTableCellObject(
              row.original && row.original.status,
              '',
              row.original
            )}
            <div
              className="appointment-delivery-cn-tracking"
              title={appointmentDetailsString}
            >
              <div className="ribbon-text">{appointmentDetailsString}</div>
            </div>
          </div>
        );
      }
      return getRetailTableCellObject(
        row.original && row.original.status,
        '',
        row.original
      );
    }
  };

  return toReturn;
}

export const internalTrackingRedirectedDashBoardConfig = returnTrackingColumns(
  internalTrackingDashboardConfig
);

export const externalTrackingRedirectedDashBoardConfig = returnTrackingColumns(
  externalTrackingDashboardConfig
);

export const trackingDashboardTableActionConfig = {};
